import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-traval-search',
  templateUrl: './traval-search.component.html',
  styleUrls: ['./traval-search.component.scss']
})
export class TravalSearchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
